/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/24/2019.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import { Card } from '@scuf/common';
import {withRouter} from "react-router";
import {CURRENT_FAULT_STATES} from '../faults/common/FaultsConst'
import AssetChart from '../common/AssetChart'

class AssetCard extends React.Component {

    goToAsset(asset) {
        const {history} = this.props
        history.push(`/assets/${asset.id}`)
    }

    getAttributesComponents() {
        const {asset} = this.props
        const attrs = []

        attrs.push(this.getAttributeRow('faultsCount', asset.faultsCount))

        CURRENT_FAULT_STATES.forEach(s => {
            attrs.push(this.getAttributeRow('faults-' + s, asset.faultStatesCount[s] || 0, 'mobile only'))
        })

        return <div>{attrs}</div>
    }

    getAttributeRow(key, value, cls) {
        const {intl} = this.props
        const name = intl.formatMessage({id: 'asset.attr.' + key})
        return <div key={key} className={"attr " + key + (cls ? (' ' + cls) : '')}><span className="attr-name">{name}: </span><span className="attr-value">{value}</span></div>
    }

    render() {
        const {asset} = this.props

        return (
            <Card onClick={() => this.goToAsset(asset)} className={'asset-card'}>
                <Card.Header>
                    <div className='name' title={asset.name}>{asset.name}</div>
                </Card.Header>
                <Card.Content>
                    <div className="attrs">
                        {this.getAttributesComponents()}
                    </div>
                    <div className="chart">
                        <AssetChart asset={asset} height={200} />
                    </div>
                </Card.Content>
            </Card>
        )
    }
}

export default injectIntl(withRouter((AssetCard)))